import type { GoalTarget } from '@/types'

type ApiGoal = { period: string; category: string; target: number }

const PERIOD_KEYS = new Set(['monthly', 'quarterly', 'annual'])

/** Converte lista da API `/goals` para o formato usado no store de Deals. */
export function mapApiGoalsToTargets(goals: ApiGoal[]): GoalTarget {
  const result: GoalTarget = {}
  for (const goal of goals) {
    if (!PERIOD_KEYS.has(goal.period)) continue
    const key = goal.period as keyof GoalTarget
    const bucket = { ...(result[key] ?? {}) }
    bucket[goal.category] = Number(goal.target)
    result[key] = bucket
  }
  return result
}

export function extractGoalsList(payload: unknown): ApiGoal[] {
  if (Array.isArray(payload)) return payload as ApiGoal[]
  if (payload && typeof payload === 'object' && Array.isArray((payload as { data?: unknown }).data)) {
    return (payload as { data: ApiGoal[] }).data
  }
  return []
}
